module.exports = __webpack_public_path__ + "img/digi-next-arrow.8b8edb3c.png";